import { Suspense, useEffect, useRef, useState } from "react";
import {
  AppShell,
  Group,
  useMantineColorScheme,
  UnstyledButton,
  ThemeIcon,
  Text,
  Burger,
  Box,
  useMantineTheme,
  Skeleton,
  ActionIcon,
} from "@mantine/core";
// import { MainLinks } from './_mainLinks';
import { User } from "./_user";
import { Logo } from "./_logo";
import logo from "../../assets/images/altitude-brand2.png";
import { MainLinks, menuData } from "./_mainLinks";
import { AltHistory } from "../../utils/history";
import { Navigate, useLocation, useNavigate } from "react-router-dom";

import { Routes, Route } from "react-router-dom";
import classes from "./Shell.module.scss";

import {
  IconLayoutSidebarLeftCollapse,
  IconLayoutSidebarLeftExpand,
  IconSettings,
} from "@tabler/icons-react";

import { getProp } from "utils/helper";
import { useDispatch } from "react-redux";
import { setUser } from "modules/Auth/authSlice";
import { logger } from "utils/logger";

import { setPreviousRoute } from "app/appSlice";
import { useDisclosure, useLocalStorage, useMediaQuery } from "@mantine/hooks";
import { SpotlightControl } from "core/components/index";
import { ModalsProvider } from "@mantine/modals";
import { AppConstants } from "utils/constants";
import {
  HomeModule,
  InventoryModule,
  DistributionModule,
  SettingsModule,
  WipModule,
  ApprovalModule,
} from "modules/index";
import TalentModule from "modules/Talent/TalentModule";
import LiveFeedModule from "modules/LiveFeed/LiveFeedModule";

function Shell({ user }) {
  const { colorScheme } = useMantineColorScheme();
  const history = AltHistory(useNavigate());
  const location = useLocation();
  const [selectedMenu, setSelectedMenu] = useState(menuData[5]);
  const [opened, { toggle }] = useDisclosure();

  const [navOpen, toggleNav] = useLocalStorage({
    key: "navOpen",
    defaultValue: true,
  });

  const theme = useMantineTheme();
  const shellRef = useRef(null);

  const dispatch = useDispatch();
  const tabletMatch = useMediaQuery(`(max-width: ${theme.breakpoints.sm})`);

  // set the user details if we have them in local storage
  useEffect(() => {
    if (!user) {
      const userStr = getProp("user");
      if (userStr) {
        const tmpUser = JSON.parse(userStr);
        dispatch(setUser(tmpUser));
      }
    }
  }, [user, dispatch]);

  const onMenuClick = (item) => {
    const tmpLoc = `${location.pathname}/${location.search}`;
    dispatch(setPreviousRoute(tmpLoc));
    history.push(item.route, true);

    if (tabletMatch) toggle();
  };

  useEffect(() => {
    let menuItem = menuData.find((item) => {
      var isFound = location.pathname.indexOf(item.route) > -1;

      // if !found also check the sub items
      if (!isFound && item.items) {
        item.items.forEach((subItem) => {
          if (location.pathname.indexOf(subItem.route) > -1) {
            isFound = true;
          }
        });
      }
      logger.log("isFound", isFound, item.route, location.pathname);
      return isFound;
    });

    logger.log("menuItem", menuItem, menuData);
    if (!menuItem && location.pathname.indexOf("/settings") > -1) {
      menuItem = { route: "/settings" };
    }
    if (menuItem && menuItem.route !== selectedMenu?.route) {
      setSelectedMenu(menuItem);
    }
  }, [location.pathname, selectedMenu, setSelectedMenu, menuData]);

  let logoBg = "transparent";
  const mouseOverHandler = (e) => {
    if (!navOpen) {
      logger.log(e);

      if (e.type === "mouseenter") {
        shellRef.current.classList.add("nav-hover");
      } else {
        shellRef.current.classList.remove("nav-hover");
      }
    }
  };

  return (
    <ModalsProvider>
      <AppShell
        layout="alt"
        className={navOpen ? "nav-open" : ""}
        ref={shellRef}
        header={{ height: 60 }}
        footer={{ height: 60 }}
        navbar={{
          width: 70,
          breakpoint: "sm",
          collapsed: { mobile: !opened },
        }}
        padding="md"
      >
        <AppShell.Header>
          <Group
            h={"100%"}
            pr={20}
            position="left"
            align="center"
            pl={"md"}
            justify="space-between"
            w={"100%"}
          >
            <Group align="center" hiddenFrom="sm">
              <Burger opened={opened} onClick={toggle} size="sm" />
              <Group hiddenFrom="sm">
                <img alt="Onset Logo" src={logo} width="100" />
              </Group>
            </Group>

            <Group justify="space-between" style={{ flexGrow: 1 }}>
              <Box visibleFrom="sm" size="sm">
                <SpotlightControl />
              </Box>
              <Group visibleFrom="sm">
                {user ? <User data={user} /> : null}
              </Group>
            </Group>
          </Group>
        </AppShell.Header>

        <AppShell.Navbar>
          <div
            id="nav-wrapper"
            className={classes.navWrapper}
            onMouseEnter={(e) => mouseOverHandler(e)}
            onMouseLeave={(e) => mouseOverHandler(e)}
          >
            <Group style={{ height: "100%" }}>
              <div
                className={classes.navbar}
                style={{ height: "100%" }}
                px="xs"
              >
                <Box
                  className={`${classes.logoBg} logoBg`}
                  sx={{ backgroundColor: logoBg }}
                ></Box>
                <Group justify="space-between">
                  <Group gap={0} pt={0}>
                    <Burger
                      pl={"xs"}
                      opened={opened}
                      onClick={toggle}
                      hiddenFrom="sm"
                      size="sm"
                      mr={18}
                    />

                    <Group className="app-header-menu-logo">
                      <Group visibleFrom="sm" pt={7} mb={7}>
                        <Logo colorScheme={colorScheme} />
                      </Group>
                      <Group hiddenFrom="sm">
                        <img alt="Onset Logo" src={logo} width="100" />
                      </Group>
                    </Group>
                  </Group>

                  <ActionIcon
                    visibleFrom="sm"
                    variant="subtle"
                    onClick={() => toggleNav(!navOpen)}
                  >
                    {navOpen ? (
                      <IconLayoutSidebarLeftCollapse
                        color={theme.white}
                        stroke={AppConstants.ICON_STROKE_WIDTH}
                      />
                    ) : (
                      <IconLayoutSidebarLeftExpand
                        color={theme.white}
                        stroke={AppConstants.ICON_STROKE_WIDTH}
                      />
                    )}
                  </ActionIcon>
                </Group>

                <div style={{ marginTop: 10, flexGrow: 1 }}>
                  <MainLinks
                    callBack={onMenuClick}
                    selectedMenu={selectedMenu}
                  />
                </div>
                <div>
                  {/* <User /> */}
                  <UnstyledButton
                    sx={{ paddingLeft: 10 }}
                    className={
                      selectedMenu && selectedMenu.route === "/settings"
                        ? `${classes.menuItem} active menu-link`
                        : `${classes.menuItem} menu-link`
                    }
                    onClick={() => onMenuClick({ route: "/settings" })}
                  >
                    <Group spacing={17}>
                      <ThemeIcon
                        size="md"
                        radius={"sm"}
                        className={classes.themeIcon}
                        variant="filled"
                        style={(theme) => ({
                          backgroundColor: "transparent",
                        })}
                      >
                        <IconSettings size={24} stroke={1.5} />
                      </ThemeIcon>

                      <Text fw={500} size="sm">
                        Settings
                      </Text>
                    </Group>
                  </UnstyledButton>
                </div>
              </div>
            </Group>
          </div>
        </AppShell.Navbar>
        <AppShell.Main px={0}>
          <Group className={classes.container} spacing="xs" style={{ gap: 0 }}>
            <div id="content-container" className={classes.mainPanel}>
              <Routes>
                <Route
                  path="/home/*"
                  element={
                    <Suspense fallback={<ModulePreloader />}>
                      <HomeModule />
                    </Suspense>
                  }
                />

                <Route
                  path="/dashboard"
                  element={
                    <Suspense fallback={<ModulePreloader />}>
                      <InventoryModule />
                    </Suspense>
                  }
                />

                <Route
                  path="/inventory/*"
                  element={
                    <Suspense fallback={<ModulePreloader />}>
                      <InventoryModule />
                    </Suspense>
                  }
                />

                <Route
                  path="/distributions/*"
                  element={
                    <Suspense fallback={<ModulePreloader />}>
                      <DistributionModule />
                    </Suspense>
                  }
                />

                <Route
                  path="/wip/*"
                  element={
                    <Suspense fallback={<ModulePreloader />}>
                      <WipModule />
                    </Suspense>
                  }
                />

                <Route
                  path="/approval/*"
                  element={
                    <Suspense fallback={<ModulePreloader />}>
                      <ApprovalModule />
                    </Suspense>
                  }
                />

                <Route
                  path="/talent/*"
                  element={
                    <Suspense fallback={<ModulePreloader />}>
                      <TalentModule />
                    </Suspense>
                  }
                />

                <Route
                  path="/settings/*"
                  element={
                    <Suspense fallback={<ModulePreloader />}>
                      <SettingsModule />
                    </Suspense>
                  }
                />

                <Route
                  path="/feed/*"
                  element={
                    <Suspense fallback={<ModulePreloader />}>
                      <LiveFeedModule />
                    </Suspense>
                  }
                />

                <Route
                  path="/"
                  element={<Navigate replace to="/inventory" />}
                />
              </Routes>
            </div>
          </Group>
        </AppShell.Main>
        {/* <AppShell.Aside p="md">Aside</AppShell.Aside> */}
        {/* <AppShell.Footer p="md">Footer</AppShell.Footer> */}
      </AppShell>
    </ModalsProvider>
  );
}

const ModulePreloader = () => {
  return (
    <div className={classes.moduleLoader}>
      <Box px="lg">
        <Group
          className="main-container-header"
          position="apart"
          sx={(theme) => ({
            borderBottom: `1px solid ${theme.colors.gray[3]}`,
            borderColor:
              theme.colorScheme === "dark"
                ? theme.colors.dark[6]
                : theme.colors.gray[2],
            backgroundColor:
              theme.colorScheme === "dark" ? theme.colors.dark[8] : theme.white,
          })}
        >
          <Skeleton height={15} width={200} mt={20} mb={20} radius="xl" />
        </Group>

        <Group
          className="container-action-bar"
          sx={{ width: "100%" }}
          position="apart"
          height={"100%"}
          py="xs"
          mt="sm"
        ></Group>
      </Box>
    </div>
  );
};
export default Shell;
